'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');
var _note = require('../../../static/icons/note.svg');var _note2 = _interopRequireDefault(_note);

var _isDescendant = require('../../utils/isDescendant');var _isDescendant2 = _interopRequireDefault(_isDescendant);

var _NoteWrapper = require('./NoteWrapper.scss');var styles = _interopRequireWildcard(_NoteWrapper);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // global
// components
// helpers
// styles
var NoteWrapper = function (_Component) {_inherits(NoteWrapper, _Component);function NoteWrapper(props) {_classCallCheck(this, NoteWrapper);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.














    handleCloseNote = function (e) {
      var isNoteIcon = _this.noteWrapper && (0, _isDescendant2.default)(_this.noteWrapper, e.target);

      if (!isNoteIcon) {
        _this.setState({ showNote: false });
      }
    };_this.











    renderNoteContent = function () {var _this$props =
      _this.props,propertyNote = _this$props.propertyNote,addPropertyNote = _this$props.addPropertyNote,noteClassName = _this$props.noteClassName,noteIconClassName = _this$props.noteIconClassName,id = _this$props.id;
      return (
        _react2.default.createElement('div', {
            className: styles.noteIconWrapper,
            id: 'note_for_' + id,
            ref: function ref(_ref) {_this.noteWrapper = _ref;} },

          _react2.default.createElement('img', {
            src: _note2.default,
            alt: '',
            className: (0, _classnames2.default)(styles.noteIcon, noteIconClassName),
            onClick: _this.toggleNote }),


          _this.state.showNote &&
          _react2.default.createElement('div', { className: styles.noteTooltip },
            _react2.default.createElement(_index.NoteInput, {
              value: propertyNote,
              addNote: addPropertyNote,
              className: (0, _classnames2.default)(styles.noteTooltipInner, noteClassName) }))));





    };_this.state = { showNote: false };_this.noteWrapper = null;_this.toggleNote = _this.toggleNote.bind(_this);return _this;}NoteWrapper.prototype.componentDidMount = function componentDidMount() {document.body.addEventListener('click', this.handleCloseNote, true);};NoteWrapper.prototype.componentWillUnmount = function componentWillUnmount() {document.body.removeEventListener('click', this.handleCloseNote, true);};NoteWrapper.prototype.toggleNote = function toggleNote(e) {e.stopPropagation();window.dispatchEvent(new CustomEvent('closeAllNotes'));this.setState(function (prevState) {return { showNote: !prevState.showNote };});};NoteWrapper.prototype.

  render = function render() {var
    propertyNote = this.props.propertyNote;

    if (!propertyNote) {
      return null;
    }

    var content = this.renderNoteContent();

    return this.props.isNoteHolder ?
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.noteIconHolder, this.props.noteIconHolderClassName) }, content) :
    content;
  };return NoteWrapper;}(_react.Component);


NoteWrapper.propTypes = {
  id: _propTypes2.default.string,
  propertyNote: _propTypes2.default.string,
  addPropertyNote: _propTypes2.default.func,
  noteClassName: _propTypes2.default.string,
  isNoteHolder: _propTypes2.default.bool,
  onToggle: _propTypes2.default.func,
  noteIconClassName: _propTypes2.default.string,
  noteIconHolderClassName: _propTypes2.default.string };exports.default =


NoteWrapper;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/NoteWrapper/NoteWrapper.js
// module id = 2749
// module chunks = 0